var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-period"},[_c('select-base',_vm._b({attrs:{"selectOptions":_vm.selectPeriodOptions,"selected":_vm.value,"width":"150px"},on:{"input":_vm.changeSelect}},'select-base',_vm.propSet,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }